export default __webpack_public_path__ + "static/media/1747.c2fee574.png";